import { Injectable, TemplateRef } from "@angular/core";
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Injectable()

export class AlertaPanico {

    private static audio: HTMLAudioElement = null;
    arrayIdsAgent: string[] = [];
    public static audioAtivo: boolean = false;

    private opcoesModal: NgbModalOptions =
    {
      backdrop: 'static',
      centered: true,
      backdropClass: 'backdrop-modal',
      windowClass: 'position-modal'
    };

    constructor(private modalService: NgbModal) {
        AlertaPanico.audio = new Audio();
        AlertaPanico.audio.src = 'assets/audios/som_panico.wav';
        AlertaPanico.audio.load();
    }

    openModal(contentPanico: TemplateRef<any>) {
      console.log("open modal **");
      this.modalService.open(contentPanico, this.opcoesModal)
        .result.then((result) => {
          //console.log(`Fechado pelo ${result}`);
          AlertaPanico.audio.play();
        }, (reason) => {
        //console.log(`Dispensado ${this.getDismissReason(reason)}`);
        AlertaPanico.audio.play();
      });

    }

    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
      return 'clicando ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'clicando fora';
      } else {
      return `por ${reason}`;
      }
    }

    play(contentPanico: TemplateRef<any> = null) {
      AlertaPanico.audioAtivo = true;
      AlertaPanico.audio.loop = true;

      const promise = AlertaPanico.audio.play();
      if(promise !== undefined){
          promise.then(() => {
              // Autoplay started
          }).catch(error => {
              // Autoplay was prevented.
              if(contentPanico != null){
                this.openModal(contentPanico);
              }
          });
      }
    }

    stop() {
      AlertaPanico.audioAtivo = false;
      AlertaPanico.audio.loop = false;
      AlertaPanico.audio.pause();
    }

    checkNewPanico(idsAgenteRecebido: string[], contentPanico: TemplateRef<any>){
      let ativaAudio = !idsAgenteRecebido.every(id => this.arrayIdsAgent.some(idRecebido => id === idRecebido));
      this.arrayIdsAgent = idsAgenteRecebido;
      if(ativaAudio){
        this.play(contentPanico);
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/alertaPanico.service.ts